import React, { useEffect } from "react";
import ApexCharts from "apexcharts";

interface ThemeToggleProps {
  isDarkTheme: boolean;
  onToggle: (next: boolean) => void;
}

const Theme: React.FC<ThemeToggleProps> = ({ isDarkTheme, onToggle }) => {

  useEffect(() => {
    if (isDarkTheme) {
      document.body.classList.add("dark-theme");
      updateApexChartsTheme("dark");
    } else {
      document.body.classList.remove("dark-theme");
      updateApexChartsTheme("light");
    }
  }, [isDarkTheme]);

  const toggleTheme = () => {
    onToggle(!isDarkTheme);
  };

  const updateApexChartsTheme = (theme: "dark" | "light") => {
    ApexCharts.exec("donutChart", "updateOptions", {
      theme: {
        mode: theme, // Change between 'dark' and 'light'
      }
    });

    ApexCharts.exec("pieChart", "updateOptions", {
      theme: {
        mode: theme, // Change between 'dark' and 'light'
      }
    });

    ApexCharts.exec("lineChart", "updateOptions", {
      theme: {
        mode: theme, // Change between 'dark' and 'light'
      }
    });
  };

  return (
    <div className="setting-item">
      <label htmlFor="theme-toggle" className="setting-label">
        <input
          id="theme-toggle"
          type="checkbox"
          checked={isDarkTheme}
          onChange={toggleTheme}
          className="setting-checkbox"
        />
        <span className="setting-text">Dark Theme</span>
      </label>
    </div>
  );
};

export default Theme;
